import { Controller, useFormContext } from 'react-hook-form'
import './SelectField.scss'
import BasicField from '../BasicField/BasicField'
import Select from 'react-select'

const SelectField = ({ name, label, optional, placeholder, validation, options }) => {
	const { control } = useFormContext()

	// 옵션이 이미 객체 배열인지 문자열 배열인지 확인
	const formattedOptions = options.every(
		(option) => typeof option === 'object' && option.value && option.label,
	)
		? options // 이미 객체 배열인 경우
		: options.map((option) => ({
				// 문자열 배열인 경우 변환
				value: option,
				label: option,
			}))

	return (
		<Controller
			name={name}
			control={control}
			rules={validation}
			render={({ field }) => (
				<BasicField
					name={name}
					label={label}
					placeholder={placeholder}
					optional={optional}
					validation={validation}
					useChildrenWrapper={false}>
					<Select
						{...field}
						isSearchable={false}
						options={formattedOptions}
						placeholder={placeholder}
						classNamePrefix="custom-select"
					/>
				</BasicField>
			)}
		/>
	)
}

export default SelectField
